import { FC } from "react";
import { Button } from "rizzui";

interface PackageDeleteProps {
  closeModal: () => void;
  onDelete: () => void;
  packageName: string;
}

const PackageProps: FC<PackageDeleteProps> = ({
  closeModal,
  onDelete,
  packageName,
}) => {
  return (
    <div className="p-4">
      <h3 className="text-lg font-semibold mb-4">Delete Package</h3>
      <p className="mb-4">
        Are you sure you want to delete the package: <b>{packageName}</b>?
      </p>
      <div className="w-full flex flex-row justify-between">
        <Button onClick={closeModal}>Cancel</Button>
        <Button
          variant="outline"
          className="border-red-400 text-black hover:border-red-600"
          onClick={onDelete}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default PackageProps;